import React from "react";
import { Link } from "react-router-dom";
import { Card, CardHead, FRow } from "@app/shared/src/components_v2";

/** Where things live — the console's map for a director's first week. */
export const HelpPage: React.FC = () => (
    <div className="flex flex-col gap-4">
        <h1 className="text-[20px] font-bold tracking-tight">Help Center</h1>

        <Card>
            <CardHead title="Getting around" />
            <div className="mt-2">
                <FRow title="Print a cab card" sub="The QR a driver scans to reach their truck — no login.">
                    <Link to="/qr" className="text-[12.5px] font-semibold text-[var(--accent)]">
                        Driver QR Codes →
                    </Link>
                </FRow>
                <FRow title="Review an incident" sub="Open any event for the full printable report — photo, clip, radar track.">
                    <Link to="/events" className="text-[12.5px] font-semibold text-[var(--accent)]">
                        Events →
                    </Link>
                </FRow>
                <FRow title="Pull footage from a truck" sub="Request a clip over LTE and watch it here when it lands.">
                    <Link to="/media" className="text-[12.5px] font-semibold text-[var(--accent)]">
                        DVR Requests →
                    </Link>
                </FRow>
                <FRow title="Check a unit's alert defaults" sub="The persistent settings every restart returns to.">
                    <Link to="/settings" className="text-[12.5px] font-semibold text-[var(--accent)]">
                        Fleet defaults →
                    </Link>
                </FRow>
            </div>
        </Card>

        <Card>
            <CardHead title="Beyond the console" />
            <div className="px-5 pb-5 pt-3 text-[13px] leading-relaxed text-[var(--muted)]">
                Adopting a new device, editing trigger thresholds, zone geometry and roles all live on the main Omnisight
                dashboard. Drivers never need any of this — their whole interface is the cab QR taped in the truck.
            </div>
        </Card>
    </div>
);
